<template> 
  <v-card v-show="isShow" tile>
    <v-container fluid style="overflow: scroll;">
      <v-card-title>開立的發票({{issuedInvoices.length}}張)(共${{totalIssuedInvoiceAmount | amountFormat}})</v-card-title>
      <v-row dense>
        <v-col
          v-for="receipt in issuedInvoices"
          :key="`issued-${receipt.ID}`"
          cols="6" sm="4" md="3" lg="3">
          <receipt-card :item="receipt" @edit="editReceipt" @remove="deleteReceipt"/>
        </v-col>
      </v-row>
      <v-card-title>收到的發票({{receivedInvoices.length}}張)(共${{totalReceivedInvoiceAmount | amountFormat}})</v-card-title>
      <v-row dense>
        <v-col
          v-for="receipt in receivedInvoices"
          :key="`received-${receipt.ID}`"
          cols="6" sm="4" md="3" lg="3">
          <receipt-card :item="receipt" @edit="editReceipt" @remove="deleteReceipt"/>
        </v-col>
      </v-row>
    </v-container>
    <v-fab-transition>

      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn
            @click="isShowAddeditDialog = true"
            v-on="on"
            v-show="isShow"
            color="black"
            dark
            absolute
            right
            bottom
            fab
            class="v-btn--fixed"
            style="bottom:28px;">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </template>
        <span>新增收據</span>
      </v-tooltip>
    </v-fab-transition>

    <receipt-addedit-dialog v-model="isShowAddeditDialog" :editing-id="editingId" :project-id="projectId"/>

    <v-overlay :value="isLoading">
      <v-progress-circular indeterminate color="white"></v-progress-circular>
    </v-overlay>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import ReceiptAddeditDialog from "@/ui/project/receipt/receipt-addedit-dialog.vue";
import ReceiptCard from "@/ui/project/receipt/receipt-card.vue";
import filterMixin from "@/data/filters/filter-mixin.vue";
export default {
  mixins: [filterMixin],
  components: { ReceiptAddeditDialog, ReceiptCard },
  props: {
    projectId: {
      type: Number,
      required: true
    },
    isShow: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    isLoading: false,
    isShowAddeditDialog: false,
    editingId: -1
  }),
  computed: {
    project() {
      return (
        this.$store.state.project.list.find(o => o.ID == this.projectId) || {}
      );
    },
    issuedInvoices() {
      if (!this.project.Receipts) return [];
      return this.project.Receipts.filter(o => o.Type == "issued");
    },
    receivedInvoices() {
      if (!this.project.Receipts) return [];
      return this.project.Receipts.filter(o => o.Type == "received");
    },
    totalIssuedInvoiceAmount () {
      return this.issuedInvoices.reduce((sum,o)=>sum+o.Amount,0)
    },
    totalReceivedInvoiceAmount () {
      return this.receivedInvoices.reduce((sum,o)=>sum+o.Amount,0)
    }
  },
  methods: {
    editReceipt(itemID) {
      this.editingId = itemID;
      this.isShowAddeditDialog = true;
    },
    deleteReceipt(id) {
      const removingIdx = this.project.Receipts.findIndex(o => o.ID == id);
      this.isLoading = true;
      this.$services.receipt
        .delete(this, id)
        .then(res => {
          this.project.Receipts.splice(removingIdx, 1);
          // this.$alertMessage("成功刪除發票!");
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
};
</script>
